import { render } from "./BasicInfo.vue?vue&type=template&id=db4816fe&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=ts"
export * from "./BasicInfo.vue?vue&type=script&lang=ts"

import "./BasicInfo.vue?vue&type=style&index=0&id=db4816fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db4816fe"

export default script